import React, { useEffect, useState } from "react";
import { green_rec, left_arrow, white_rec } from "../../assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { useLazyReviewListStatusQuery, useLazyReviewListViewQuery, useReviewListStatusMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import moment from "moment";

const Reviews = () => {

  const [list, setList] = useState([]);
  const [star, setStar] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const routeType = location?.state?.routeType;
  const id = location?.state?.data;
  console.log("route", id);


  const [ReviewListApi] = useLazyReviewListViewQuery();
  const [reviewListStatus] = useReviewListStatusMutation();


  const reviewStatus = (id, value) => {
    const formdata = new FormData();
    formdata.append("id", id)
    formdata.append("status", value)
    reviewListStatus(formdata)
      .unwrap()
      .then((res) => {
        console.log("reasds", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          if (id) {
            reviewView(id);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  const reviewView = (id) => {
    ReviewListApi(id)
      .unwrap()
      .then((res) => {
        console.log("reasds", res);
        setList(res?.data)
        let temp = {
          ...res?.data
        }
        let rat_ = []
        for (let i = 0; i < res?.data?.rating; i++) {
          rat_.push(i)
        }
        temp.rating_arr = rat_
        setStar(temp)
        {
          console.log("llll", temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
  }



  useEffect(() => {
    if (id) {
      reviewView(id);
    }
  }, [])

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Review {routeType} View
        </h2>
      </div>
      <div className="d-flex ac-js gap-2" onClick={() => navigate(-1)}>
        <img src={left_arrow} className="leftArrow mb-3" />
        <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
          Back
        </p>
      </div>
      <div className="">
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Property Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Property Name"
              value={list?.property?.name}
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Owner Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Owner Name"
              value={list?.property?.owner}
            />
          </div>
        </div>

        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              User Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="User Name"
              value={list?.reviewer?.name}
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Star Rating
            </h4>
            <p className="d-flex w-100">
              {star?.rating_arr?.map((item, ind) => {
                return (
                  <p className="mt-1" key={ind}>
                    <StarIcon style={{ color: "#ffc108" }} />{" "}
                  </p>
                );
              })}
            </p>
          </div>
        </div>

        <div className="d-flex gap-5 mb-4">
          <div className="col-md-4">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Status
            </h4>
            <select
              value={list?.status}
              onChange={(e) => { reviewStatus(list?.id, e.target.value) }}
              className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${list?.status == 2 ? "active-btn" : list?.status == 3 ? "suspend-btn" : "blocked-btn"}`}
            >
              <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={2}>
                Active
              </option>
              <option className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={3} >
                Deactive
              </option>
              <option disabled className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black" value={1} >
                Requested
              </option>
            </select>
          </div>

          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Date and Time
            </h4>
            <div className="d-flex ac-js gap-5">
              <input
                className="input-pop ps-2 w-100"
                placeholder="Owner Name"
                value={moment(list?.created_at).format("DD-MM-YYYY")}
              />
              <input
                className="input-pop ps-2 w-100"
                placeholder="Owner Name"
                value={moment(list?.created_at).format("h:mm:ss a")}
              />
            </div>
          </div>
        </div>

        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Booking ID
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Booking ID"
              value={list?.booking?.booking_id}
            />
          </div>
        </div>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-10">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Description
            </h4>
            <textarea
              type="text"
              className="input-pop ps-2 w-100 h-100"
              placeholder="Description"
              rows={4}
              value={list?.review ? list?.review : "Null"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
